"use client";
import { getNoAvailability, saveNoAvailability } from "@/lib/features/hotel/hotelSlice";
import { useAppDispatch, useAppSelector } from "@/lib/hooks";
import { makeQueryString, parseQueryString } from "@/utils/queryString";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import React, { useEffect, useMemo, useState } from "react";
import Skeleton from "react-loading-skeleton"; // Import the skeleton loader
import "react-loading-skeleton/dist/skeleton.css"; // Import styles for skeleton loader

const Overview = ({ hotel, loading }: { hotel: any; loading: boolean }) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const noAvailability = useAppSelector(getNoAvailability);
  
  const query: any = useSearchParams();

  const payloadFromQuery: any = useMemo(() => {
    return query ? parseQueryString(query) : null;
  }, [query]);
  
  useEffect(() => {
    if (!noAvailability) return;
  
    console.log("No availability", noAvailability, payloadFromQuery);
  
    const { hotel_code, search_id, dates, ...rest } = payloadFromQuery;
  
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    let updatedDates = dates;
  
    // ✅ Check if dates exist and are in the past
    if (
      Array.isArray(dates) &&
      dates.length === 2 &&
      new Date(dates[1]) < today
    ) {
      // 📅 Start date = next month from today
      const startDate = new Date(today);
      startDate.setMonth(startDate.getMonth() + 1);
  
      // 📅 End date = start date + 2 days
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 2);
  
      // Format as YYYY-MM-DD
      const formatDate = (date: Date) =>
        date.toISOString().split("T")[0];
  
      updatedDates = [
        formatDate(startDate),
        formatDate(endDate),
      ];
    }
  
    const url = makeQueryString({
      ...rest,
      dates: updatedDates,
    });
  
    dispatch(saveNoAvailability(false));
  
    console.log("url=>>><<<<<<<", url);
    // 🚀 Redirect
    router.push(`/hotels?${url}`);
  }, [noAvailability, dispatch, router, payloadFromQuery]);
  

  
  const [showFull, setShowFull] = useState(false);

  const toggleShowMore = () => {
    setShowFull(!showFull);
  };

  // Define the number of characters to show in the truncated description
  const maxLength = 500;
  const description = hotel?.description ?? "";

  // Show the full description if showFull is true, otherwise show a truncated version
  const displayedDescription = showFull
    ? description
    : `${description.slice(0, maxLength)}...`;

  return (
    <>
      <h3 className="text-22 fw-500 pt-40 border-top-light">Overview</h3>
      {loading ? (
        // Show skeleton loaders if data is loading
        Array(2)
          .fill(0)
          .map((_, index) => (
            <div className="text-dark-1 text-15 mt-20">
              <p>
                <b>
                  <Skeleton />
                </b>
                <Skeleton />
              </p>
              <p>
                <b><Skeleton /></b>
                <Skeleton />
              </p>
            </div>
          ))
      ) : (
        <>
          <p
            className="text-dark-1 text-15 mt-20"
            dangerouslySetInnerHTML={{ __html: displayedDescription }}
          ></p>
          {description?.length > maxLength && (
            <button
              className="d-block text-14 text-blue-1 fw-500 underline mt-10"
              onClick={(e) => {
                toggleShowMore();
              }}
            >
              {showFull ? "Show Less" : "Show More"}
            </button>
          )}
        </>
      )}
    </>
  );
};

export default Overview;
